<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-content" :style="modalStyle">
      <button class="close-button" @click="closeModal">×</button>
      <div class="modal-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '80%'
    },
    height: {
      type: String,
      default: '80%'
    }
  },
  computed: {
     modalStyle() {
      return {
        backgroundImage: `url(${this.imageUrl})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
         width: this.width,
        height: this.height
      };
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
}

.modal-content {
  position: relative;
  max-width: 600px;
  max-height: 400px;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
}

.close-button {
  position: absolute;
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 27px; /* 根据需要调整宽度 */
  height: 27px; /* 根据需要调整高度 */
  background-image: url('../../assets/shop/closes.png'); /* 替换为你的关闭按钮图片路径 */
  background-size: contain;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  padding-top: 40px; /* To give space for the close button */
}
.contentH{
    font-size: 18px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 186px;
    color: #666;
    text-align: center;
}
.top42 {
    top: 42%;
}
.top60 {
    top: 65%;
}
.top64 {
    top: 70%;
}
.contentP{
    font-size: 18px;
    color: #666;
    position: absolute;
    left: 50%;
    top: 54%;
    transform: translate(-50%, -50%);
    max-width: 186px;
    .contentP_1{
        font-size: 25px;
        font-weight: 600;
        color: red;
    }
}
</style>